




















































import { Component } from 'vue-property-decorator';
import Vue from '@/vue.type';
import Logo from '@/assets/images/mandala-logo.png';
import UserAvatarComponent from '../avatars/user/user-avatar.component.vue';
import UserAvatar from '../avatars/user/user-avatar.class';
import { version } from '../../../package.json';
import MandalaLagsDisplay from './mandala-lags-display.component.vue';

@Component({
  components: {
    UserAvatarComponent,
    MandalaLagsDisplay,
  },
})
export default class MandalaHeaderComponent extends Vue {
  private images: any = {
    sample: Logo,
  };

  private user: UserAvatar = new UserAvatar({ name: this.$store.getters.getUser.name });

  private profile() {}

  private config() {}

  private logout() {
    this.$store.dispatch('logout');
    this.$router.push('/login');
  }

  private appVersion() {
    return version;
  }
}
